import { render, staticRenderFns } from "./WipoXmlForm.vue?vue&type=template&id=f7506ddc&"
import script from "./WipoXmlForm.vue?vue&type=script&lang=js&"
export * from "./WipoXmlForm.vue?vue&type=script&lang=js&"
import style0 from "./WipoXmlForm.vue?vue&type=style&index=0&id=f7506ddc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports